import { Button, Center, Stack, Text, Title } from "@mantine/core";
import { IconMoodSad } from "@tabler/icons-react";
import { NavLink, useRouteError } from "react-router-dom";

interface Props {
  children?: React.ReactNode;
}
/**
 * To be used specifically with react-router v6
 */
export function RouterErrorBoundary({ children }: Props) {
  const error = useRouteError();

  if (error) {
    console.error("Error boundary caught an error: ", { error });
    return (
      <Center h="100vh">
        <Stack align="center">
          <IconMoodSad size={100} color="red" />
          <Title c="black">Whoops, Something went wrong.</Title>
          <Text c="black">
            {(error as unknown as Error)?.message ||
              "An unexpected error occurred. Please try refreshing or returning home"}
          </Text>
          <Button component={NavLink} to="/home" mt="md">
            Return Home
          </Button>
        </Stack>
      </Center>
    );
  }

  return children;
}
